import React from "react";
import Link from "next/link";

import { Action } from "@/constants/events";
import { Dispensary } from "@/custom-types/Dispensary";
import { DispensaryReview } from "@/custom-types/Reviews";
import useDomainCountryCode from "@/hooks/useDomainCountryCode";
import { useEventTracker } from "@/hooks/useEventTracker";
import { dispensaryHref } from "@/utils/dispensaryUrls";

import NoReviews from "@/components/Dispensary/Reviews/components/NoReviews";
import ReviewContainer from "@/components/Dispensary/Reviews/components/ReviewContainer";
import ReviewsHeader from "@/components/Dispensary/ReviewsHeader";

const ReviewsOverview: React.FC<{
  dispensary: Dispensary;
  ratingsWithoutContent: number;
  reviews?: DispensaryReview[];
  totalReviews: number;
}> = ({ dispensary, ratingsWithoutContent, reviews, totalReviews }) => {
  const { slug, retailType } = dispensary;
  const { publishEvent } = useEventTracker();
  const countryCode = useDomainCountryCode();

  const onClick = () => {
    publishEvent({
      action: Action.Click,
      category: "Dispensary Menu",
      label: "See all Reviews Button",
    });
  };

  const href = dispensaryHref({
    additionalPath: "/reviews",
    countryCode,
    retailType,
    slug,
  });

  return (
    <div id="reviews-overview">
      <ReviewsHeader
        dispensary={dispensary}
        ratingsWithoutContent={ratingsWithoutContent}
        totalReviews={totalReviews}
      />
      {reviews && reviews.length > 0 ? (
        <>
          <div className="mt-lg">
            {reviews.map((review) => (
              <ReviewContainer
                retailType={retailType}
                review={review}
                key={review.id}
                hideMetadata={true}
              />
            ))}
          </div>
          <Link
            prefetch={false}
            href={href}
            data-testid="reviews-overview-see-all"
            onClick={onClick}
            className="button button--secondary"
          >
            see all reviews
          </Link>
        </>
      ) : (
        <NoReviews dispensary={dispensary} />
      )}
    </div>
  );
};

export default ReviewsOverview;
